<template>
    <div class="txt-gift-box">
        <div class="gift-order-id">
            <IconInput :placeholder="amsHolder" class="input" @inputChange="amsIdChange" :initValue="currentData.amsId" />
            <IconInput :placeholder="groupHolder" class="input" @inputChange="groupChange" :initValue="currentData.groupId" />
        </div>
        <div class="gift-img-txt">
            <PackageIcon v-model="currentData.cardImage" />
            <div class="gift-txt">
                <IconInput :placeholder="titleHolder" class="title-input" @inputChange="titleChange" :initValue="currentData.packageName" />
                <div class="textarea"><textarea :placeholder="descHolder" v-model="currentData.packageDesc"></textarea></div>
            </div>
        </div>
        <ReplyItem
            v-for="(item, key, index) in currentData.tips"
            :key="index"
            :data="Object.assign({}, item, { replyType: key })"
            @replyTextChange="replyTextHandle"
        />
    </div>
</template>

<script>
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import PackageIcon from "./packageItem/PackageIcon";
import ReplyItem from "./packageItem/ReplyItem";

export default {
    name: "Package",
    props: ["data"],
    components: {
        IconInput,
        PackageIcon,
        ReplyItem
    },
    data() {
        return {
            currentData: this.data
        };
    },
    computed: {
        amsHolder() {
            return this.$t("zhiji.answer.packageWidge.amsHolder");
        },
        groupHolder() {
            return this.$t("zhiji.answer.packageWidge.groupHolder");
        },
        titleHolder() {
            return this.$t("zhiji.answer.packageWidge.titleHolder");
        },
        descHolder() {
            return this.$t("zhiji.answer.packageWidge.descHolder");
        }
    },
    watch: {
        currentData: {
            handler(value, oldValue) {
                if (!oldValue) {
                    // 初始化时，不需要提交变动
                    return;
                }
                this.commitStore(value);
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        amsIdChange(data) {
            this.currentData.amsId = data;
        },
        groupChange(data) {
            this.currentData.groupId = data;
        },
        titleChange(data) {
            this.currentData.packageName = data;
        },
        replyTextHandle(data) {
            this.currentData.tips[data.replyType] = data;
        },
        commitStore(widget) {
            widget.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContent",
                widget: widget
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.txt-gift-box {
    margin-right: 16px;
    padding: 16px;
    width: 500px;
    box-sizing: border-box;
    background: #f2f7fb;
    border-radius: 4px;
    /deep/.div-textarea-container {
        border-radius: 4px 4px 0 0;
    }
    .gift-order-id {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
    }
    .gift-txt {
        position: relative;
        display: flex;
        flex: 1;
        flex-direction: column;
        border: 1px solid #d8e4f0;

        .title-input {
            width: 100%;
            border: none;
            border-bottom: 1px solid #d8e4f0;
            /deep/input {
                &:focus {
                    border-radius: 0;
                }
            }
        }

        .textarea {
            flex: 1;
            width: 100%;
            box-sizing: border-box;
            background: #fff;
            textarea {
                width: 100%;
                height: 100%;
                overflow-y: auto;
                border: 1px solid transparent;
                padding: 6px 8px;
                &:focus {
                    border-color: #2088f3;
                }
            }
        }
    }
    /deep/.text-textarea > .textarea {
        width: 468px;
    }
    /deep/.text-textarea > .textarea,
    /deep/.div-textarea-container .textarea-value {
        background: #fff;
    }
}

.gift-img-txt {
    margin-bottom: 8px;
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    border-radius: 4px;
    border: 1px solid #d8e4f0;
}

.input {
    width: 230px;
    border: 1px solid #d8e4f0 !important;
    border-radius: 5px !important;
}
.gift-img {
    /deep/.no-cover-icon-h {
        flex-direction: column;
        width: 22px;
        height: 20px;
        margin-bottom: 4px;
    }
    /deep/.no-cover-panel-h {
        flex-direction: column;
        background: #fff;
        border-radius: 4px;
        &:hover {
            .no-cover-icon-h {
                background-position-y: -74px !important;
            }
        }
    }
}
</style>
